export const devModuleCustomFiles = [
  `css!/cloudstore/config/devStatic/devModuleStyle.css?v=${Date.now()}`,
  `/cloudstore/config/devStatic/devModuleCustom.js?v=${Date.now()}`,
];

export const ecComFiles = ['/cloudstore/resource/pc/com/v1/ecCom.min.js'];

export const comMobxFiles = ['/spa/coms/index.mobx.css', '/spa/coms/index.mobx.js'];

export const portalPublicFiles = ['/spa/portal/public/index.css', '/spa/portal/public/index.js'];



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/constants/files.js